export const SCROLL_TYPE = {
  NONE: "none",
  SCROLL: "scroll"
};
